import { isTenant } from './helpers/general.js'

let routes = [

  { path: '/:pathMatch(.*)*', name: 'NotFound', component: () => import('./page/404.vue') }
]

const centralRoutes = [
  {
    path: '/email',
    component: () => import('./layout/AuthLayout.vue'),
    children: [
      {
        name: 'checkVerifyEmail',
        path: 'verify/:id/:hash',
        component: () => import('./page/Auth/AuthCheckVerifyEmail.vue')
      },
    ]
  },
  {
    path: '/auth',
    component: () => import('./layout/AuthLayout.vue'),
    children: [
        {
            name: 'noAccess',
            path: 'no-access',
            component: () => import('./page/Auth/NoAccess.vue')
        },
      {
        name: 'login',
        path: 'login',
        component: () => import('./page/Auth/AuthLogin.vue')
      },
      {
        name: 'logout',
        path: 'logout',
        component: () => import('./page/Auth/AuthLogout.vue')
      },
      {
        name: 'selectTenant',
        path: 'select-tenant',
        component: () => import('./page/Auth/AuthSelectTenant.vue')
      },
      {
        name: 'verifyEmail',
        path: 'verify-email',
        component: () => import('./page/Auth/AuthVerifyEmail.vue')
      },

      {
        name: 'register',
        path: 'register',
        component: () => import('./page/Auth/AuthRegister.vue')
      },
      {
        name: 'forgottenPassword',
        path: 'forgotten-password',
        component: () => import('./page/Auth/AuthForgottenPassword.vue')
      },
      {
        name: 'resetPassword',
        path: 'reset-password',
        component: () => import('./page/Auth/AuthResetPassword.vue')
      }
    ]
  },
  {
    path: '/',
    component: () => import('./layout/DashboardLayout.vue'),
    meta: { requiresAuth: true },
    children: [
      {
        name: 'dashboard',
        path: '',
        component: () => import('./page/CentralDashboard.vue')
      },
      {
        name: 'users',
        path: '/users',
        component: () => import('./page/UsersList.vue')
      },
      {
        name: 'trainings',
        path: '/trainings',
        component: () => import('./page/TrainingList.vue')
      },
    {
        name: 'pdfs',
        path: '/pdfs',
        component: () => import('./page/PDFList.vue')
    },
      {
        name: 'groups',
        path: '/groups',
        component: () => import('./page/GroupList.vue')
      },
      {
        name: 'schemas',
        path: '/schemas',
        component: () => import('./page/SchemaList.vue')
      },
      {
        name: 'licensekeys',
        path: '/license-keys',
        component: () => import('./page/LicenseKeyList.vue')
      },
      {
        name: 'tenants',
        path: '/tenants',
        component: () => import('./page/TenantList.vue')
      }
    ]
  },
]

const tenantRoutes = [
  {
    path: '/',
    component: () => import('./layout/DashboardLayout.vue'),
    meta: { requiresAuth: true },
    children: [
      {
        name: 'dashboard',
        path: '',
        component: () => import('./page/CentralDashboard.vue')
      },
      {
        name: 'users',
        path: '/users',
        component: () => import('./page/UsersList.vue')
      },
        {
            name: 'pdfs',
            path: '/pdfs',
            component: () => import('./page/PDFList.vue')
        },
      {
        name: 'groups',
        path: '/groups',
        component: () => import('./page/GroupList.vue')
      },
      {
        name: 'trainings',
        path: '/trainings',
        component: () => import('./page/TrainingList.vue')
      },
      {
        name: 'schemas',
        path: '/schemas',
        component: () => import('./page/SchemaList.vue')
      },
    ]
  },
]

if (isTenant()) {
  routes = [...routes, ...tenantRoutes]
} else {
  routes = [...routes, ...centralRoutes]
}

export default routes
